/**
 * Data Constants
 * Assessment data, dropdown options, journey questions, and other static data
 */

export const USER_ROLES = {
  SUPERADMIN: 0,
  ADMIN: 1,
  LEADER: 2,
  DISCIPLE: 3
};

export const TIMING = {
  COUNTDOWN: 30,
  DEBOUNCE_TIMEOUT: 500
};

export const IDS = {
  SD_INDIVIDUAL_ORGANIZATION: 2,
  BREAK_BOOK_ID: 9999
};

export const DATES = {
  APPLICATION_REGISTRATION_DATE: '01-01-2026',
  DATE_FORMAT: 'Do MMMM, YYYY',
  DATE_FORMAT_2: 'MMMM D, YYYY',
  DATE_FORMAT_3: 'MM/DD/YY',
  MONTH_YEAR_FORMAT: 'MMM, YYYY',
  NO_MEETING_UNDEFINED: 'undefined - undefined'
};

export const DISCIPLE_JOURNEY_IDS = {
  JOURNEY_1: '51,52,53,54',
  JOURNEY_2: '55,56',
  LEADER_JOURNEY: '1,2,3,4,5,6',
  ASSEMENT_ONE: [7, 8],
  ASSEMENT_TWO: '20,21,29,55,59,60,73',
  JOURNEY_ANSWERS: '55,56,67,68,69,70,71,72'
};

export const QUESTION_OPTIONS = {
  DISCIPLE_OPTIONS: {
    55: [
      {id: 1, label: 'Which one are you? Pick just one.', options: ['Introvert', 'Extrovert', 'Ambivert']},
      {id: 2, label: '', options: ['Go', 'Send']},
      {id: 3, label: '', options: ['Lead', 'Follow']},
      {id: 4, label: '', options: ['Tell', 'Listen']},
      {id: 5, label: 'What type of learner are you?', options: ['Visual', 'Auditory', 'Both']},
      {id: 6, label: 'Which best describes how you feel or process information?', options: ['Emotional', 'Engineer', 'Activist']}
    ]
  }
};

export const LEADER_JOURNEY_QUESTIONS = [
  {
    id: 1,
    width: '100%',
    label: "I'VE ATTENDED",
    type: 'checkbox',
    options: ['Live Workshop', 'Virtual Workshop', 'N/A'],
    selectedAnswers: []
  },
  {
    id: 2,
    width: '100%',
    label: "I'VE READ",
    type: 'checkbox',
    options: ['How to Make Disciples', 'Well Made Well Done', 'N/A'],
    selectedAnswers: []
  },
  {
    id: 3,
    width: '50%',
    label: "I'VE PARTICIPATED IN",
    type: 'checkbox',
    options: ['D1', 'D2', 'D3', 'N/A', 'Outside Discipleship'],
    selectedAnswers: []
  },
  {
    id: 4,
    width: '50%',
    label: "I'VE LEAD",
    type: 'checkbox',
    options: ['D1', 'D2', 'D3', 'N/A'],
    selectedAnswers: []
  },
  {
    id: 5,
    width: '50%',
    label: "I'VE BEEN COACHED",
    type: 'radio',
    options: ['Yes', 'No'],
    selectedAnswers: ''
  },
  {
    id: 6,
    width: '50%',
    label: 'I WANT COACHING',
    type: 'radio',
    options: ['Yes', 'No'],
    selectedAnswers: ''
  }
];

export const ASSESSMENT_QUESTIONS_IDS = {
  ASSESSMENT_1: '[7,8]',
  ASSESSMENT_2: '[9,10,11]',
  ASSESSMENT_3: '[13,14,15,16,17,18,19,44,45,46,47,48,49,50]',
  ASSESSMENT_4: '[20,21]',
  ASSESSMENT_5: '[23,24,25,26,27]',
  ASSESSMENT_6: '[28]',
  ASSESSMENT_7: '[29,30,31]',
  ASSESSMENT_8: '[32,33,34,35]',
  ASSESSMENT_9: '[32,33,34,35]',
  ASSESSMENT_10: '[36,42,43,37]',
  ASSESSMENT_11: '[38,39]',
  ASSESSMENT_12: '[40,41,57]',
  ASSESSMENT_13: '[7,59,60,13,14,15,16,17,18,19,44,45,46,47,48,49,50]',
  ASSESSMENT_14: '[20,21,29]',
  ASSESSMENT_15: '[64,65,66,67,68,69,70,71,72]',
  ASSESSMENT_16: '[7,8,13,14,15,16,17,18,19,44,45,46,47,48,49,50,20,21,29,59,60]'
};

export const DOING_ASSESSMENT = [
  {
    value: 'Nothing (Simply a Consumer, Getting a Paycheck)',
    label: 'Nothing (Simply a Consumer, Getting a Paycheck)',
    score: 0
  },
  {
    value: `Consistently Applying God's Truths (New and Old)`,
    label: `Consistently Applying God's Truths (New and Old)`,
    score: 2
  },
  {value: 'Eager to be Taught', label: 'Eager to be Taught', score: 3},
  {
    value: 'Volunteer (Parking, Greeting, Kids, Helping Outside of Job Description)',
    label: 'Volunteer (Parking, Greeting, Kids, Helping Outside of Job Description)',
    score: 6
  },
  {
    value: 'Learning to Learn (Following On Their Own, Self-Starter)',
    label: 'Learning to Learn (Following On Their Own, Self-Starter)',
    score: 7
  },
  {
    value: 'Learning to Lead (Leading Volunteers, Assistant Manager)',
    label: 'Learning to Lead (Leading Volunteers, Assistant Manager)',
    score: 10
  },
  {
    value: 'Leading Leaders (Pastor or Senior Leader, Executive)',
    label: 'Leading Leaders (Pastor or Senior Leader, Executive)',
    score: 11
  },
  {
    value: 'Influencing/Teaching (Small Groups, Visionary, Management)',
    label: 'Influencing/Teaching (Small Groups, Visionary, Management)',
    score: 14
  },
  {
    value: 'Reaching the World (Missionary, Blogging/Speaking)',
    label: 'Reaching the World (Missionary, Blogging/Speaking)',
    score: 14
  }
];

export const BE_ASSESSMENT = [
  {
    value: 'Not Hearing from God or Bible',
    label: 'Not Hearing from God or Bible',
    score: 0
  },
  {
    value: 'Hearing, Seeing and Not Doing (Guilty? Idle?)',
    label: 'Hearing, Seeing and Not Doing (Guilty? Idle?)',
    score: 1
  },
  {
    value: 'Hearing, Applying, and Getting It',
    label: 'Hearing, Applying, and Getting It',
    score: 4
  },
  {
    value: 'Asking to Serve, Compelled to Join God in His Work',
    label: 'Asking to Serve, Compelled to Join God in His Work',
    score: 5
  },
  {
    value: 'They know what to do and why to do it',
    label: 'They know what to do and why to do it',
    score: 8
  },
  {
    value: `They are following on their own (you don't have to push much anymore)`,
    label: `They are following on their own (you don't have to push much anymore)`,
    score: 9
  },
  {
    value: 'They are all in on following God and serving God',
    label: 'They are all in on following God and serving God',
    score: 9
  },
  {
    value: `They are a servant not just serving (always available for God's greater plan.)`,
    label: `They are a servant not just serving (always available for God's greater plan.)`,
    score: 12
  },
  {
    value: `They are focused on championing God's kingdom. It isn't about them or theirs.`,
    label: `They are focused on championing God's kingdom. It isn't about them or theirs.`,
    score: 14
  }
];

export const STEP_DROPDOWNS = [
  {label: '0', value: 0},
  {label: '1', value: 1},
  {label: '2', value: 2},
  {label: '3', value: 3},
  {label: '4', value: 4},
  {label: '5', value: 5},
  {label: '6', value: 6},
  {label: '7', value: 7},
  {label: '8', value: 8},
  {label: '9', value: 9},
  {label: '10', value: 10},
  {label: '11', value: 11},
  {label: '12', value: 12},
  {label: '13', value: 13},
  {label: '14', value: 14}
];

export const ASSESSMENT_STEP_MESSAGES = {
  13: `They have regular highlights. They are hearing "to dos" and "not dos" from the Word. When
  asked, "How do you apply this?" ,they can see a clear action plan and they are adjust to God's
  truths each time rather than pushing back.`,
  15: `Their action based on conviction has shown them a better way. They now know that they don't
  know everything. They are hungry to learn and becoming enlightened. The Word is
  transforming their mind, their thoughts, and decisions.`,
  17: `They are feeling compelled to get into the game. Compelled to do something with this thriving
  faith. They ask for something to do for the Body and are doing it. They are showing up to serve
  everywhere.`,
  19: `They are learning on their own. They have learned to learn and know how to find what they
  don't know. They are prepared and confident when it comes to making decisions based on
  God's eternal truths.`,
  45: `They are all in to follow Christ - however, wherever. No questions asked. If they moved to
  Timbuktu, they would find a church or start one and follow Christ. They are ready to take the
  first steps of leadership in the Body of Christ. They are humble, waiting their turn, and want to
  learn.`,
  47: `They have learned to lead and are successfully leading others in the Body of Christ on their
  own. They have seen that it is a privilege to serve God. They aren't just serving, they're
  servants, waiting on Him, to do only and anything He calls them to do.`,
  49: `They are a servant of the Most High King and they realize the Kingdom is not about their home,
  job, church, or thing. They are invested in His Kingdom so much that they are willing to
  separate and go serve Him wherever, whenever.`
};

export const READINGS = {
  MYSTICAL_CHAPTER: {
    label: 'Mystical Chapters',
    value: 'Mystical Chapters'
  }
};

export const BADGES = {
  WINNIER_ONE_STAR: 'winner-one',
  WINNIER_TWO_STAR: 'winner-two',
  WINNIER_THREE_STAR: 'winner-three',
  GOODJOB_ONE_STAR: 'good-job-one',
  GOODJOB_TWO_STAR: 'good-job-one',
  GOODJOB_THREE_STAR: 'good-job-one'
};

export const ALL_WEEKS = [
  {label: '42', value: 42},
  {label: '43', value: 43},
  {label: '44', value: 44},
  {label: '45', value: 45},
  {label: '46', value: 46},
  {label: '47', value: 47},
  {label: '48', value: 48}
];

export const TIMEZONE_OPTIONS = [
  {value: 'EST', label: 'New York (America/New_York)', offset: 'GMT-5:00'},
  {value: 'CST', label: 'Chicago (America/Chicago)', offset: 'GMT-6:00'},
  {value: 'MDT', label: 'Denver (America/Denver)', offset: 'GMT-7:00'},
  {value: 'MST', label: 'Phoenix (America/Phoenix)', offset: 'GMT-7:00'},
  {value: 'PST', label: 'Los Angeles (America/Los_Angeles)', offset: 'GMT-8:00'},
  {value: 'AST', label: 'Halifax (America/Halifax)', offset: 'GMT-4:00'},
  {value: 'ART', label: 'America/Argentina/Buenos_Aires', offset: 'GMT-3:00'},
  {value: 'BRT', label: 'America/Sao_Paulo', offset: 'GMT-3:00'},
  {value: 'WST', label: 'Europe/London', offset: 'GMT+8:00'},
  {value: 'CET', label: 'Europe/Paris', offset: 'GMT+1:00'},
  {value: 'EET', label: 'Europe/Istanbul', offset: 'GMT+3:00'},
  {value: 'MSK', label: 'Europe/Moscow', offset: 'GMT+3:00'},
  {value: 'WAT', label: 'Africa/Lagos', offset: 'GMT+1:00'},
  {value: 'CAT', label: 'Africa/Johannesburg', offset: 'GMT+2:00'},
  {value: 'EAT', label: 'Africa/Nairobi', offset: 'GMT+3:00'},
  {value: 'IST', label: 'Asia/Kolkata', offset: 'GMT+5:30'},
  {value: 'PKT', label: 'Asia/Karachi', offset: 'GMT+5:00'},
  {value: 'JST', label: 'Asia/Tokyo', offset: 'GMT+9:00'},
  {value: 'AEST', label: 'Australia/Sydney', offset: 'GMT+1:00'},
  {value: 'NZST', label: 'Pacific/Auckland', offset: 'GMT+3:00'},
  {value: 'IRST', label: 'Asia/Tehran', offset: 'GMT+3:30'},
  {value: 'GST', label: 'Asia/Dubai', offset: 'GMT+4:00'},
  {value: 'UTC', label: 'UTC', offset: 'GMT+0:00'}
];

export const COUNTRIES = ['Australia', 'Benin Republic', 'Botswana', 'Burkina Faso', 'Burundi', 'Chad', 'Columbia', "Cote d' Ivoire", 'Ethiopia', 'Gambia', 'Germany', 'Ghana', 'Great Britain', 'Guatemala', 'Guinea Conakry', 'India', 'Indonesia', 'Italy', 'Kenya', 'Liberia', 'Malawi ', 'Mali', 'Mexico', 'Mozambique', 'Myanmar/Burma', 'Niger', 'Nigeria', 'Rwanda', 'Senegal', 'Sierra Lionne', 'South Africa', 'South Sudan', 'Spain', 'Sweden', 'Tanzania', 'Togo', 'Uganda', 'United States of America', 'Wales', 'Zambia', 'Zimbabwe'];

// `value` is the locale FILE name in public/locales, not an ISO code — two of them are
// historical misnomers that are now load-bearing (they are keys in the DB, in the backend's
// getLanguageSuffix(), and in ~18 SendGrid template names each): `sw` is Swedish, not
// Swahili, and `ben` is English-UK, not Bengali. Do NOT "correct" them.
//
// `dir` drives the document direction. Only Urdu is RTL among the shipped set.
export const LANG = {
  1: {key: 1, value: 'en', name: 'English', dir: 'ltr'},
  2: {key: 2, value: 'es', name: 'Spanish', dir: 'ltr'},
  3: {key: 3, value: 'sw', name: 'Swedish', dir: 'ltr'},
  4: {key: 4, value: 'ben', name: 'English(UK)', dir: 'ltr'},
  5: {key: 5, value: 'mex', name: 'Mexico(Spanish)', dir: 'ltr'},
  6: {key: 6, value: 'hi', name: 'Hindi', dir: 'ltr'},
  7: {key: 7, value: 'ur', name: 'Urdu', dir: 'rtl'},
  8: {key: 8, value: 'or', name: 'Odia', dir: 'ltr'}
};

// LANGUAGES is the OFFERED list — what the switcher and the org/user language pickers show.
// It is NOT the same as LANG above, which is the full registry of every locale the app knows how
// to render. A locale belongs in LANG as soon as its bundle exists; it belongs HERE only once it
// is fit to put in front of a user.
//
// Re-enabling a language means uncommenting it HERE **and** in components/LanguageSwitcher.js,
// which hardcodes its flag buttons instead of mapping this list. Hiding it in one place leaves it
// reachable from the other.
export const LANGUAGES = [
  {value: 1, label: 'English'},
  {value: 2, label: 'Spanish'},
  {value: 3, label: 'Swedish'},
  {value: 4, label: 'English(UK)'},
  {value: 5, label: 'Mexico(Spanish)'}
  // Hindi (6) is OFF on this branch pending review (PO, 2026-08-14). Unlike the two below this
  // is a REVIEW gate, not a translation gap: hi.json is key-complete (`i18n-extract.js --locale
  // hi` reports 0 missing of 1,680) and uses the register Indian Christians use — चेला not
  // शिष्य, अगुवा not नेता, since नेता reads as *politician*. It shipped enabled on draft-day
  // 2026-07-29 and was switched back off for the SOW-9 merge review.
  // {value: 6, label: 'Hindi'}
  //
  // Urdu (7) stays OFF: ur.json is ~1,556 keys short of 1,680, and Urdu additionally needs real
  // RTL layout QA. Offering an incomplete bundle is the worst failure mode in this app —
  // translate() falls back to the key, the key IS the English string, so the user silently gets
  // English with nothing logged (F-085). Enable only when `i18n-extract.js --locale ur` reports
  // 0 missing.
  // {value: 7, label: 'Urdu'}
  //
  // Odia (8) stays OFF pending NATIVE-SPEAKER REVIEW. The bundle is key-complete
  // (`i18n-extract.js --locale or` reports 0 missing) but is a machine-generated first draft
  // nobody who speaks Odia has read; the discipleship register is the risk. moment also ships no
  // `or` locale, so dates would stay English. Review workbook:
  // sdtests/docs/languages/OR_TRANSLATION_REVIEW.xlsx
  // {value: 8, label: 'Odia'}
];

export const MOMENTLOCALEMAP = {
  en: 'en',
  es: 'es',
  sw: 'sv',
  mex: 'es-mx',
  ben: 'en-gb',
  hi: 'hi',
  ur: 'ur',
  // moment ships no Odia locale (node_modules/moment/locale/ has bn, hi, ur — no or.js),
  // so dates/times render in English even when the rest of the UI is Odia. This is a known
  // gap, not a typo — mapping `or` to a wrong-but-present Indic locale (bn/hi) would print
  // confidently incorrect month and weekday names, which is worse. Revisit if moment adds
  // `or`, or when this app moves off moment.
  or: 'en'
};

export const QUESTION_IDS_FOR_UPDATE_ANSWERS = {
  60: '67,68,69',
  55: '70,71',
  56: '72'
};

export const ANSWER_TRANSFORM_MAP = {
  67: {Yes: 'Tithing'},
  68: {Yes: 'Attending'},
  69: {Yes: 'Serving'},
  70: {
    energized: 'Extrovert',
    'Being around people': 'Introvert',
    equally: 'Ambivert'
  },
  71: {
    'Feel the story': 'Emotional',
    'Notice every detail': 'Engineer',
    'Get frustrated': 'Activist'
  }
};
